import React from "react";

import {LeadModel} from "@/typings/models/Lead";
import PrettyDate from "@/components/PrettyDate";

import styles from "./index.less"
import {F} from "@/utils/intl";

const LeadUpdatedAt = ({lead, isTable}: {lead: LeadModel, isTable?: boolean}) => {
  const content = <PrettyDate date={lead.modified}/>

  if (isTable) return content

  return <div>
    <div className={styles.tinyDateKey}><F id={"pages.lead.fields.updatedAt"} defaultMessage={"Updated at"}/></div>
    <div><PrettyDate date={lead.modified}/></div>
  </div>

}

export default LeadUpdatedAt
